export const loginPath = '/login/';
export const logoutPath = '/logout';
